import { render, staticRenderFns } from "./SelectPermissionDailog.component.vue?vue&type=template&id=96232cf8&scoped=true"
import script from "./SelectPermissionDailog.component.vue?vue&type=script&lang=js"
export * from "./SelectPermissionDailog.component.vue?vue&type=script&lang=js"
import style0 from "./SelectPermissionDailog.component.vue?vue&type=style&index=0&id=96232cf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96232cf8",
  null
  
)

export default component.exports